package com.rosario.juridico

import kotlinx.datetime.*
import kotlinx.browser.window
import kotlinx.browser.localStorage
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch

class JsPlatform : Platform {
    override val name: String = "Web with Kotlin/JS"
    override val isDevelopment: Boolean 
        get() = window.location.hostname == "localhost" || window.location.hostname == "127.0.0.1"
}

actual fun getPlatform(): Platform = JsPlatform()

actual fun openWhatsApp(number: String) {
    val url = "https://wa.me/$number"
    window.open(url, "_blank")
}

actual fun openEmail(address: String) {
    val url = "mailto:$address"
    window.location.href = url
}

actual fun openPhone(number: String) {
    val url = "tel:$number"
    window.location.href = url
}

actual fun openUrl(url: String) {
    window.open(url, "_blank")
}

actual fun currentDateString(): String {
    val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    val d = now.dayOfMonth.toString().padStart(2, '0')
    val m = now.monthNumber.toString().padStart(2, '0')
    return "$d/$m/${now.year}"
}

actual fun isFirstTime(key: String): Boolean {
    // Si no existe la clave en localStorage, es la primera vez
    return localStorage.getItem(key) == null
}

actual fun setFirstTimeSeen(key: String) {
    // Guardamos 'false' para indicar que ya no es la primera vez
    localStorage.setItem(key, "false")
}

actual fun exitApp() {
    // En la web no se puede cerrar la aplicación de la misma forma que en Android.
    // Una opción es redirigir a una página de salida o simplemente no hacer nada.
    println("Exit App called on JS Platform")
}

actual fun persistString(key: String, value: String) {
    localStorage.setItem(key, value)
}

actual fun getPersistedString(key: String): String? {
    return localStorage.getItem(key)
}

actual fun persistLong(key: String, value: Long) {
    localStorage.setItem(key, value.toString())
}

actual fun getPersistedLong(key: String): Long {
    return localStorage.getItem(key)?.toLongOrNull() ?: 0L
}

actual fun compartirTexto(texto: String) {
    if (window.navigator.asDynamic().share != null) {
        window.navigator.asDynamic().share(js("{text: texto}"))
    } else {
        // Fallback: Copiar al portapapeles o mostrar un mensaje
        window.alert("La función compartir no está disponible en este navegador. Copie el texto manualmente.")
        println(texto)
    }
}

actual fun launchGoogleSignIn(onResult: (idToken: String?) -> Unit) {
    println("[GOOGLE] Launching Google Sign-In via Firebase signInWithPopup")
    onResult("web_google_popup")
}